import { DataSource, Label, Layout, Table, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutSendInfoPacket extends Layout {
    labelAttachments: Label;
    sourceInfoPacketHeader: DataSource;
    sourceInformationPacket: DataSource;
    sourceProspectAction: DataSource;
    tableAttachments: Table;
    textboxCC: Textbox;
    textboxComment: Textbox;
    textboxCustomerId: Textbox;
    textboxEmail: Textbox;
    textboxSubject: Textbox;
}
